<template>
  <div style="margin-left: 20px">
    欢迎使用本系统
  </div>
</template>

<script>
export default {
  name: 'defaultModel',
  data() {
    return {


    }
  },
  created() {
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>


.leadBox {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-size: 100% 100%;
}
</style>

